import {Routes} from '@angular/router';

export const content: Routes = [
  {
    path: 'home',
    loadChildren: () => import('../../layouts/components/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'general/coordinator',
    loadChildren: () => import('../../layouts/components/coordinator/coordinator.module').then(m => m.CoordinatorModule)
  },
  {
    path: 'general/session',
    loadChildren: () => import('../../layouts/components/session/session.module').then(m => m.SessionModule)
  },
  {
    path: 'subject',
    loadChildren: () => import('../../layouts/components/subject/subject.module').then(m => m.SubjectModule)
  },
  {
    path: 'questions',
    loadChildren: () => import('../../layouts/components/questions/questions.module').then(m => m.QuestionsModule)
  },
  {
    path: 'student',
    loadChildren: () => import('../../layouts/components/student/student.module').then(m => m.StudentModule)
  },
  {
    path: 'student-mapping',
    loadChildren: () => import('../../layouts/components/student-mapping/student-mapping.module').then(m => m.StudentMappingModule)
  },
  {
    path: 'monitoring',
    loadChildren: () => import('../../layouts/components/monitoring/monitoring.module').then(m => m.MonitoringModule)
  },
  {
    path: 'evaluation',
    loadChildren: () => import('../../layouts/components/evaluation/evaluation.module').then(m => m.EvaluationModule)
  },
  {
    path: 'result',
    loadChildren: () => import('../../layouts/components/result/result.module').then(m => m.ResultModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('../../layouts/components/notification/notification.module').then(m => m.NotificationModule)
  },
  {
    path: 'support-ticket',
    loadChildren: () => import('../../layouts/components/support-ticket/support-ticket.module').then(m => m.SupportTicketModule)
  },
  {
    path: 'help',
    loadChildren: () => import('../../layouts/components/help-support/help-support.module').then(m => m.HelpSupportModule)
  },
];

export const landing: Routes = [
  {
    path: 'landing',
    loadChildren: () => import('../../landing/pages-list/Landing/Landing.module').then(m => m.LandingModule)
  }
];
